import {HTMLAttributes} from 'react';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import {ListItemAvatar, ListItemText, ListItem} from '@mui/material';
import {Avatar} from '@mui/material';
import {TFunction} from 'i18next';
export default function FullBodySiteItem({
  liProps,
  t
}: {
  t: TFunction;
  liProps?: HTMLAttributes<HTMLLIElement>;
}) {
  return (
    <ListItem data-testid="fullBodySiteOption" {...liProps}>
      <ListItemAvatar>
        <FullBodySiteAvatar />
      </ListItemAvatar>
      <ListItemText primary={t('ui:diagnosticReport.fullBody')} />
    </ListItem>
  );
}

export function FullBodySiteAvatar() {
  return (
    <Avatar
      variant="rounded"
      sx={{
        height: 56,
        width: 56,
        mr: 2,
        bgcolor: 'secondary.main'
      }}
    >
      <AccessibilityIcon />
    </Avatar>
  );
}
